import callApi from 'services'

export default {
  getVictimList() {
    return callApi('victims', 'GET')
  },
}
